"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonaStatus = exports.RequestKbaErrors = void 0;
var RequestKbaErrors;
(function (RequestKbaErrors) {
    // Generic error so we don't leak information back to the client
    RequestKbaErrors["REQUEST_FAILED"] = "REQUEST_FAILED";
    RequestKbaErrors["YOUNGER_THAN_MINIMUM_AGE"] = "YOUNGER_THAN_MINIMUM_AGE";
})(RequestKbaErrors || (exports.RequestKbaErrors = RequestKbaErrors = {}));
var PersonaStatus;
(function (PersonaStatus) {
    PersonaStatus["WAITING_TO_BE_COMPLETED"] = "WAITING_TO_BE_COMPLETED";
    PersonaStatus["NOT_NEEDED"] = "NOT_NEEDED";
})(PersonaStatus || (exports.PersonaStatus = PersonaStatus = {}));
